<div class="quote-card">
  <section class="quote-card__content">
    <div class="quote-card__header">
      <h2 class="quote-card__heading">Hi, {{ clientName }}</h2>
    </div>
    <div class="quote-card__body">
      <h3 class="quote-card__subheading">
        {{ greeting }}
      </h3>
      <div *ngIf="false" class="quote-card__spinner-container">
        <img class="quote-card__spinner" src="/img/components/transition-card/loading-spinner-white.gif" />
      </div>
      <div class="quote-info">
        <div class="quote-info__column">
          <div class="quote-info__details">
            <!--Insured -->
            <h4 class="quote-info__details-heading">Insured</h4>
            <span class="quote-info__name">{{ insuredName }}</span>
          </div>
          <div class="quote-info__details" *ngIf="shouldShowPremium || insuredInfo.isAgentSubmittedApp">
            <div class="quote-info__details">
              <div class="quote-info__details-tooltip">
                <h4 class="quote-info__details-heading">{{ premiumLabel }}</h4>
                <client-cost-breakdown
                  *ngIf="!!insuredInfo"
                  [safeInviteInfo]="insuredInfo"
                  class="quote-info__details-breakdown"
                ></client-cost-breakdown>
              </div>
              <div class="quote-info__name">
                <p>
                  <span class="quote-info__premium-amount-dollar-sign">$</span>
                  <span>
                    {{ totalPremium | casCurrency: 2:false }}
                    <span class="quote-info__frequency">
                      /{{ frequencyUnit }}
                      <span *ngIf="isART">*</span>
                    </span>
                  </span>
                </p>
                <div *ngIf="hasExchange1035TowardsPremium()" class="quote-info__details-text">
                  <span>{{ totalPremium - exchange1035Premium | casCurrency }} due for initial premium</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="quote-info__divider"></div>
        <div class="quote-info__column">
          <div class="quote-info__details">
            <h4 class="quote-info__details-heading">
              <span *ngIf="hasAlir">Initial</span>
              <span>Total</span>
              <span>Coverage</span>
            </h4>
            <div class="quote-info__face-amount">
              <span class="quote-info__face-amount--dollar-sign">$</span>
              <span>{{ totalCoverage | casCurrency: 0:false }}</span>
            </div>
          </div>
          <ng-container *ngIf="showFaceAmountBreakdown; else noFaceAmountBreakdown">
            <h4 class="quote-info__details-heading">
              <span *ngIf="hasAlir">Initial</span>
              <span>Coverage Includes</span>
            </h4>
            <ng-container *ngIf="hasTermPolicy">
              <div class="quote-info__details-item">
                <h4 *ngIf="isART" class="quote-info__details-text">{{ artDescription }}</h4>
                <h4 *ngIf="!isART" class="quote-info__details-text">{{ term }}-Year Convertible Term</h4>
                <h4 class="quote-info__details-item-value">{{ termFaceAmount | casCurrency: 0 }}</h4>
              </div>
            </ng-container>
            <ng-container *ngIf="hasWholeLifePolicy">
              <div class="quote-info__details-item">
                <h4 class="quote-info__details-text">Whole Life {{ wholeTerm }}</h4>
                <h4 class="quote-info__details-item-value">{{ wholeFaceAmount | casCurrency: 0 }}</h4>
              </div>
              <div class="quote-info__details-item" *ngIf="hasRtr">
                <h4 class="quote-info__details-text">Renewable Term Rider</h4>
                <h4 class="quote-info__details-item-value">{{ rtrAmount | casCurrency: 0 }}</h4>
              </div>
              <div
                class="quote-info__details-item"
                *ngIf="(hasAlir && !hasExchange1035TowardsPremium()) || exchange1035FundsExceedPremium()"
              >
                <h4 class="quote-info__details-text">
                  Additional Life Insurance Rider
                  <span *ngIf="exchange1035FundsExceedPremium()">(estimated)</span>
                </h4>
                <h4 class="quote-info__details-item-value">
                  {{ alirAmount | casCurrency: 0 }}
                </h4>
              </div>
            </ng-container>
          </ng-container>
          <ng-template #noFaceAmountBreakdown>
            <ng-container *ngIf="hasTermPolicy">
              <h4 class="quote-info__details-heading">Term</h4>
              <div class="quote-info__product-view">
                <h4 *ngIf="isART; else convertibleTerm" class="quote-info__details-text">{{ artDescription }}</h4>
                <ng-template #convertibleTerm>
                  <h4 class="quote-info__name">{{ term }} Year</h4>
                  <h4 class="quote-info__details-text">Convertible Term</h4>
                </ng-template>
              </div>
            </ng-container>
            <ng-container *ngIf="hasWholeLifePolicy">
              <h4 class="quote-info__details-heading">Product</h4>
              <div class="quote-info__details-item">
                <h4 class="quote-info__details-text">MassMutual Whole Life {{ wholeTerm }}</h4>
              </div>
            </ng-container>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="quote-card__footer">
      <quote-card-text-description
        *ngIf="shouldShowPremium || insuredInfo.isAgentSubmittedApp"
      ></quote-card-text-description>
      <div class="quote-card__alert-container" *ngIf="skipTlic">
        <alert id="skip-tlic-disclaimer" [isOpen]="skipTlic" [intent]="alertIntent.INFO">
          <b>This policy does not include an optional feature for Temporary Life Insurance Coverage.</b>
          <p>
            Any coverage will not begin until your first premium is paid and the policy takes effect. If you would like
            to be offered Temporary Life Insurance, please contact your financial professional. You still must qualify
            for the Temporary Life Insurance Coverage.
          </p>
        </alert>
      </div>
      <div
        class="quote-card__apply-now-button-container"
        *ngIf="!nbDecommissionPost30Days && insuredInfo && !insuredInfo.isAgentSubmittedApp"
      >
        <button cpdsButton theme="mm-dark" class="quote-card__apply-now-button" (click)="applyWithQuote()">
          Apply Now
        </button>
      </div>
      <div class="quote-card__apply-now-button-container" *ngIf="insuredInfo && insuredInfo.isAgentSubmittedApp">
        <button
          *ngIf="!hasRegistered"
          cpdsButton
          theme="mm-dark"
          class="quote-card__apply-now-button-container"
          (click)="applyWithQuote()"
        >
          Continue to create account
        </button>
        <button
          *ngIf="hasRegistered"
          cpdsButton
          theme="mm-dark"
          class="quote-card__apply-now-button-container"
          (click)="applyWithQuote()"
        >
          Continue to log in
        </button>
      </div>
    </div>
    <p
      *ngIf="
        !nbDecommissionPost30Days && hasTermPolicy && !isART && !hasWholeLifePolicy && !insuredInfo.isAgentSubmittedApp
      "
      class="quote-card__footer-text quote-card__footer-text--centered"
    >
      <a class="quote-card__footer-link" (click)="scrollToQuickQuote()" href="javascript:void(0)">
        Need to change something?
      </a>
    </p>
    <div *ngIf="!nbDecommissionPost30Days">
      <p class="quote-card__solicitation-disclaimer">
        MassMutual is licensed to sell insurance products in all 50 states of the United States (including the District
        of Columbia) and Puerto Rico (collectively, the “US”). By clicking “Apply Now,” you are confirming that you are
        currently located in the US.
        <b>If you are not located in the US, please do not continue with this application.</b>
        If we determine that you were located outside of the US at the time you completed this application, you
        understand and agree that we
        <b><u>will not</u></b>
        issue a policy to you and/or we may rescind any coverage issued in connection with this application.
      </p>
    </div>
    <div *ngIf="nbDecommissionPost30Days">
      <p class="quote-card__solicitation-disclaimer">
        MassMutual is licensed to sell insurance products in all 50 states of the United States (including the District
        of Columbia) and Puerto Rico (collectively, the “US”).
        <b>If you are not located in the US, please do not continue with this application.</b>
        If we determine that you were located outside of the US at the time you completed this application, you
        understand and agree that we
        <b><u>will not</u></b>
        issue a policy to you and/or we may rescind any coverage issued in connection with this application.
      </p>
    </div>
    <whole-life-visualization
      *ngIf="showWholeLifeVisualization && (shouldShowPremium || insuredInfo.isAgentSubmittedApp)"
    ></whole-life-visualization>
  </section>
</div>
